import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Api_Url } from "../../config/config";
import axios from "axios";
import { Button, Divider, Modal, Table } from "antd";
import { Toast } from "react-bootstrap";
import {
  ErrorToast,
  SuccessToast,
  UpdatedToast,
} from "../../views/ToastComponent";

function GroceryStoreDetails() {
  const { id } = useParams();

  const [singleData, setSingleData] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [rawMaterial, setRawMaterial] = useState([]);
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);

  const getSingleUser = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Grocery/sale/getbygroceryid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setSingleData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  const [monthData, setMonthData] = useState([]);

  const MonthDataFetch = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/Common/months`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setMonthData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    MonthDataFetch();
  }, []);

  const [groceryData, setGroceryData] = useState({
    groceryId: id,
    year: 0,
    month: 0,
    creditSale: 0,
    cashSale: 0,
    remark: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGroceryData({
          ...groceryData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/Grocery/sale`,
        groceryData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Added Successfully");
        handleIncomeCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error.message;
    }
  };

  // Calculations

  const totalLength = singleData.length;

  // const creditSale = singleData.map((credit) =>(credit.creditSale))
  const [averageOfCredit, setAverageOfCredit] = useState([]);
  const [averageOfCash, setAverageOfCash] = useState([]);

  useEffect(() => {
    // Calculate average of creditSale
    const totalCreditSale = singleData.reduce(
      (acc, item) => acc + item.creditSale,
      0
    );
    const averageOfCreditSale = totalCreditSale / singleData.length || 0;
    setAverageOfCredit(averageOfCreditSale);

    // Calculate average of cashSale
    const totalCashSale = singleData.reduce(
      (acc, item) => acc + item.cashSale,
      0
    );
    const averageOfCashSale = totalCashSale / singleData.length || 0;
    setAverageOfCash(averageOfCashSale);
  }, [singleData]);

  // const AvgOfCash = (averageOfCash / totalLength)
  // const AvgOfCredit = (averageOfCredit / totalLength)
  const Totalsale = averageOfCredit + averageOfCash;

  // Single user Api

  const handleClick = async (id) => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Grocery/sale/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setGroceryData(response.data?.data);
      setIsEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  //update Method

  const handleUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/Grocery/sale/${id}`,
        groceryData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated");
        handleIncomeCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  // edit profit

  const HandleSingleProfitUser = async (id) => {
    let response;
    try {
      response = await axios.get(`${Api_Url}api/v1/Grocery/item/${id}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setMarginProfitData(response.data.data);
      setISMarginEditMOdalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  // UPdate Profit Margin

  const handleProffitUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/Grocery/item/${id}`,
        marginProfitData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated");
        handleCancel();
        AllFetchMArginProfitFUnction();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  const col = [
    {
      title: "Item Name",
      dataIndex: "itemName",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Industry Margin",
      dataIndex: "industryMargin",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    {
      title: "Sale Ratio",
      dataIndex: "saleRatio",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Sale Ratio Value",
      dataIndex: "saleRatioValue",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Gross Profit",
      dataIndex: "grossProfit",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => HandleSingleProfitUser(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  // 2nd Column

  const columns = [
    {
      title: "Month",
      dataIndex: "",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
      render: (text, record) => (
        <div>
          {text.month} - {text.year}
        </div>
      ),
    },
    {
      title: "Credit Sale",
      dataIndex: "creditSale",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    {
      title: "Cash Sale",
      dataIndex: "cashSale",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            className="btn btn-danger"
            type="primary"
            // onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const [isMarginModalOpen, setISMarginMOdalOpen] = useState(false);
  const [isMarginEditModalOpen, setISMarginEditMOdalOpen] = useState(false);
  const [AllMarginItemData, setAllMarginItemData] = useState([]);
  // const [selectedRawMaterial, setSelectedRawMaterial] = useState([]);
  // const [GroceryMarginProductData, setGroceryMarginProductData] = useState([]);

  const AllFetchMArginProfitFUnction = async () => {
    let response;
    try {
      response = await axios.get(
        `${Api_Url}api/v1/Grocery/item/getbyuserid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllMarginItemData(response.data.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFetchMArginProfitFUnction();
  }, []);

  const [marginProfitData, setMarginProfitData] = useState({
    groceryId: id,
    itemId: 0,
    industryMargin: 0,
    saleRatio: 0,
    saleRatioValue: 0,
    grossProfit: 0,
    latitude: "",
    longitude: "",
  });
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setMarginProfitData({
          ...marginProfitData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleMarginProfitSubmit = async () => {
    let response;
    try {
      response = await axios.post(
        `${Api_Url}api/v1/Grocery/item`,
        marginProfitData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Added Successfully");
        handleCancel();
        AllFetchMArginProfitFUnction();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error.message;
    }
  };

  // Calculation Dtaa

  const SaleRatioTotalValue = () => {
    const result = (Totalsale * marginProfitData.saleRatio) / 100 || 0;
    // const industry =selectedRawMaterial?.industryMargin || 0;
    const grossProfitValue = result * marginProfitData.industryMargin;
    setMarginProfitData((prev) => ({
      ...prev,
      saleRatioValue: result,
      grossProfit: grossProfitValue / 100,
    }));
  };

  useEffect(() => {
    SaleRatioTotalValue();
  }, [marginProfitData.saleRatio, marginProfitData.industryMargin]);

  // Edit Function
  async function handleCancel() {
    setMarginProfitData({
      ...marginProfitData,
      groceryId: id,
      itemId: 0,
      industryMargin: 0,
      saleRatio: 0,
      saleRatioValue: 0,
      grossProfit: 0,
    });

    setISMarginEditMOdalOpen(false);
    setISMarginMOdalOpen(false);
  }

  async function handleIncomeCancel() {
    setGroceryData({
      ...groceryData,
      groceryId: id,
      year: 0,
      month: 0,
      creditSale: 0,
      cashSale: 0,
      remark: "",
    });

    setIsEditModalOpen(false); // reset form with initial value 0
    setIsModalOpen(false);
  }

  // Data fetch

  const fetchRawMaterials = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Item/getitembyprofileid/11`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setRawMaterial(response.data.data);
    } catch (error) {
      console.error("Error fetching raw materials:", error.message);
    }
  };

  useEffect(() => {
    fetchRawMaterials();
  }, []);

  const handleRawMaterialChange = (itemId) => {
    const selectedMaterial = rawMaterial.find(
      (material) => material.id == itemId
    );
    setSelectedRawMaterial(selectedMaterial);
    setMarginProfitData((prevData) => ({
      ...prevData,
      itemId,
      industryMargin: selectedMaterial ? selectedMaterial.industryMargin : 0,
    }));
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Tabs Income calculations */}

          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                class="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Income Calculations
              </button>
              <button
                class="nav-link"
                id="nav-profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
              >
                Margin calculation
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              {/* Income Data Tb */}

              <div className="row">
                <div className="col-12 d-flex align-items-center justify-content-between">
                  <h3 className="mb-0">Add Grocery</h3>
                  <button
                    className="btn btn-primary submit-btn mb-2"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Add Grocery Store
                  </button>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12 mx-auto">
                  <Table
                    className="table-striped"
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    dataSource={singleData}
                    rowKey={(record) => record.id}
                  />
                </div>
              </div>
            </div>
          </div>
          <Modal
            title={<h4>Grocery Assesment</h4>}
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => handleIncomeCancel()}
            footer={[
              <div className="d-flex justify-content-between align-items-center">
                <button
                  key="Cancel"
                  className="btn btn-danger submit-btn"
                  type="button"
                  onClick={handleIncomeCancel}
                >
                  Cancel
                </button>
                ,
                <button
                  key="submit"
                  className="btn btn-primary submit-btn"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>,
            ]}
            width={600}
            mask={false}
            maskClosable={false}
            closeIcon={<span style={{ color: 'red' }}>X</span>}
          >
            <div className="modal-body mt-5">
              <form>
                <Divider>Grocery Assesment</Divider>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <select
                        className="form-control"
                        value={groceryData.month}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            month: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Month</option>
                        {monthData &&
                          monthData.length > 0 &&
                          monthData.map((res) => (
                            <option value={res.id}>{res.name}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <select
                        className="form-control"
                        value={groceryData.year}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            year: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Year</option>s
                        <option value={2023}>2023</option>
                        <option value={2024}>2024</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Credit Sale:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Credit Sale"
                        value={groceryData.creditSale}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            creditSale: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Cash Sale:</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Cash Sale"
                        value={groceryData.cashSale}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            cashSale: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Remark:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Remark"
                        value={groceryData.remark}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            remark: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>

          {/* Edit Modal */}

          <Modal
            title={<h4>Grocery Assesment</h4>}
            open={isEditModalOpen}
            onOk={() => setIsEditModalOpen(false)}
            onCancel={() => handleIncomeCancel()}
            footer={[
              <div className="d-flex justify-content-between align-items-center">
                <button
                  key="Cancel"
                  className="btn btn-danger submit-btn"
                  type="button"
                  onClick={handleIncomeCancel}
                >
                  Cancel
                </button>
                ,
                <button
                  key="submit"
                  className="btn btn-primary submit-btn"
                  type="submit"
                  onClick={() => handleUpdate(groceryData.id)}
                >
                  Submit
                </button>
              </div>,
            ]}
            width={600}
            mask={false}
            maskClosable={false}
            closeIcon={<span style={{ color: 'red' }}>X</span>}
          >
            <div className="modal-body mt-5">
              <form>
                <Divider>Grocery Assesment</Divider>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <select
                        className="form-control"
                        value={groceryData.month}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            month: e.target.value,
                          })
                        }
                      >
                        {monthData &&
                          monthData.length > 0 &&
                          monthData.map((res) => (
                            <option value={res.id}>{res.name}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <select
                        className="form-control"
                        value={groceryData.year}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            year: e.target.value,
                          })
                        }
                      >
                        <option value={2023}>2023</option>
                        <option value={2024}>2024</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Credit Sale:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Credit Sale"
                        value={groceryData.creditSale}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            creditSale: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Cash Sale:</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="Enter Cash Sale"
                        value={groceryData.cashSale}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            cashSale: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Remark:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Remark"
                        value={groceryData.remark}
                        onChange={(e) =>
                          setGroceryData({
                            ...groceryData,
                            remark: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>

          <div
            class="tab-pane fade"
            id="nav-profile"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
          >
            {/* Margin Calcu;lation */}

            <div className="row">
              <div className="col-12 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Add Grocery</h3>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={() => setISMarginMOdalOpen(true)}
                >
                  Add Margin Calculation
                </button>
              </div>
            </div>

            {/* TAble */}

            <div className="row mt-4">
              <div className="col-12 mx-auto">
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={col}
                  dataSource={AllMarginItemData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>

            {/* Add MOdal */}

            <Modal
              title={<h4>Grocery Assesment</h4>}
              open={isMarginModalOpen}
              onOk={() => setISMarginMOdalOpen(false)}
              onCancel={() => handleCancel()}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  ,
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={handleMarginProfitSubmit}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
              <div className="modal-body mt-5">
                <h5 className="text-end text-danger">
                  Total Amount: {Totalsale}
                </h5>
                <form>
                  <Divider>Grocery Assesment</Divider>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Item Name:</label>
                        <select
                          className="form-control"
                          value={marginProfitData?.itemId}
                          onChange={(e) =>
                            handleRawMaterialChange(e.target.value)
                          }
                        >
                          <option value="">Select Item</option>
                          {rawMaterial.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <h5>
                          Industry Margin : {marginProfitData?.industryMargin}
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Sale Ratio:</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Sale Ratio"
                          value={marginProfitData.saleRatio}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value <= 100) {
                              setMarginProfitData({
                                ...marginProfitData,
                                saleRatio: value,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="row"></div> */}
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Sale Ratio Value: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(marginProfitData.saleRatioValue.toFixed(2))}
                      </span>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Gross Profit: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(marginProfitData.grossProfit.toFixed(2))}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>

            {/* edit Modal  */}

            <Modal
              title={<h4>Grocery Assesment</h4>}
              open={isMarginEditModalOpen}
              onOk={() => setISMarginEditMOdalOpen(false)}
              onCancel={() => handleCancel()}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  ,
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={() => handleProffitUpdate(marginProfitData.id)}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              mask={false}
              maskClosable={false}
              closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
              <div className="modal-body mt-5">
                <h5 className="text-end text-danger">
                  Total Amount: {Totalsale}
                </h5>
                <form>
                  <Divider>Grocery Assesment</Divider>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Item Name:</label>
                        <select
                          className="form-control"
                          value={marginProfitData.itemId}
                          onChange={(e) =>
                            handleRawMaterialChange(e.target.value)
                          }
                        >
                          <option value="">Select Item</option>
                          {rawMaterial.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <h5>
                          Industry Margin : {marginProfitData?.industryMargin}
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Sale Ratio:</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Sale Ratio"
                          value={marginProfitData.saleRatio}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value <= 100) {
                              setMarginProfitData({
                                ...marginProfitData,
                                saleRatio: value,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="row"></div> */}
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Sale Ratio Value: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(marginProfitData.saleRatioValue.toFixed(2))}
                      </span>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Gross Profit: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(marginProfitData.grossProfit.toFixed(2))}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default GroceryStoreDetails;
